/**
 * Dogfood aid: a small fixed badge that flips this tab between the old
 * PlayChess and PlayChessV2 lanes. It writes the per-user override
 * (`localStorage.play_v2`), re-locks the tab and reloads — a reload is required
 * because the SDK cannot unregister the lane's socket handlers.
 * Rendered only for users inside the rollout (`canSwitchLane`, fix AE).
 */
import React from 'react';
import {Pressable, StyleSheet, Text} from 'react-native';

import {Lane, lockLane, setLaneOverride} from './playFlags';

type Props = {lane: Lane};

function LaneToggle({lane}: Props) {
  const other: Lane = lane === 'new' ? 'old' : 'new';
  const onPress = () => {
    setLaneOverride(other);
    lockLane(other);
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };
  return (
    <Pressable
      accessibilityRole="button"
      testID="play-lane-toggle"
      onPress={onPress}
      style={[styles.badge, lane === 'new' ? styles.newLane : styles.oldLane]}>
      <Text style={styles.text}>
        {lane === 'new' ? 'V2 lane' : 'OLD lane'} · switch to{' '}
        {other.toUpperCase()}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  badge: {
    position: 'absolute',
    left: 12,
    bottom: 12,
    zIndex: 9999,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 6,
    opacity: 0.9,
  },
  newLane: {backgroundColor: '#1b5e20'},
  oldLane: {backgroundColor: '#4a4a4a'},
  text: {color: '#fff', fontSize: 12, fontWeight: '600'},
});

export default React.memo(LaneToggle);
